module.exports = __webpack_public_path__ + "static/media/iPhoneXS-SpaceGray.66bd9004.png";